var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "card" }, [
    _vm._m(0),
    _vm._v(" "),
    _c(
      "div",
      { staticClass: "card-body p-0" },
      [
        [
          _c("v-data-table", {
            staticClass: "elevation-1",
            attrs: {
              headers: _vm.headers,
              items: _vm.items.data,
              options: _vm.options,
              "show-expand": "",
              "single-expand": true,
              expanded: _vm.expanded,
              "server-items-length": _vm.items.total,
              loading: _vm.loading,
              "footer-props": {
                "items-per-page-options": [5, 10, 50, 100],
              },
            },
            on: {
              "update:options": function ($event) {
                _vm.options = $event
              },
              "update:expanded": function ($event) {
                _vm.expanded = $event
              },
            },
            scopedSlots: _vm._u(
              [
                {
                  key: "item.id",
                  fn: function (ref) {
                    var item = ref.item
                    return [
                      _vm._v(
                        "\n                    " +
                          _vm._s(item.type) +
                          _vm._s(item.id) +
                          "\n                "
                      ),
                    ]
                  },
                },
                {
                  key: "item.state.name",
                  fn: function (ref) {
                    var item = ref.item
                    return [
                      _c(
                        "span",
                        {
                          staticClass: "badge badge-pill",
                          class: item.state.labels
                            ? item.state.labels
                            : "badge-light",
                        },
                        [_vm._v(_vm._s(item.state.name))]
                      ),
                    ]
                  },
                },
                {
                  key: "item.description",
                  fn: function (ref) {
                    var item = ref.item
                    return [
                      _c(
                        "v-tooltip",
                        {
                          staticClass: "mx-1",
                          attrs: { bottom: "" },
                          scopedSlots: _vm._u(
                            [
                              {
                                key: "activator",
                                fn: function (ref) {
                                  var on = ref.on
                                  var attrs = ref.attrs
                                  return [
                                    Array.isArray(item.description)
                                      ? _c(
                                          "div",
                                          _vm._g(
                                            _vm._b(
                                              { staticClass: "nowrap" },
                                              "div",
                                              attrs,
                                              false
                                            ),
                                            on
                                          ),
                                          [
                                            _vm._v(
                                              "\n                                " +
                                                _vm._s(item.description[0]) +
                                                " ...\n                            "
                                            ),
                                          ]
                                        )
                                      : _vm._e(),
                                  ]
                                },
                              },
                            ],
                            null,
                            true
                          ),
                        },
                        [
                          _vm._v(" "),
                          _c(
                            "small",
                            _vm._l(
                              item.description,
                              function (description, key) {
                                return _c("div", { key: key }, [
                                  _vm._v(_vm._s(description)),
                                ])
                              }
                            ),
                            0
                          ),
                        ]
                      ),
                    ]
                  },
                },
                {
                  key: "expanded-item",
                  fn: function (ref) {
                    var headers = ref.headers
                    var item = ref.item
                    return [
                      _c("td", { attrs: { colspan: "100%" } }, [
                        _c("div", { staticClass: "row py-2" }, [
                          _c(
                            "div",
                            { staticClass: "col-lg-4 mb-2" },
                            [
                              _c(
                                "v-tooltip",
                                {
                                  staticClass: "mx-1",
                                  attrs: { bottom: "" },
                                  scopedSlots: _vm._u(
                                    [
                                      {
                                        key: "activator",
                                        fn: function (ref) {
                                          var on = ref.on
                                          var attrs = ref.attrs
                                          return [
                                            Array.isArray(item.description)
                                              ? _c(
                                                  "div",
                                                  _vm._g(
                                                    _vm._b(
                                                      { staticClass: "nowrap" },
                                                      "div",
                                                      attrs,
                                                      false
                                                    ),
                                                    on
                                                  ),
                                                  [
                                                    _vm._v(
                                                      "\n                                            " +
                                                        _vm._s(
                                                          item.description[0]
                                                        ) +
                                                        " ...\n                                        "
                                                    ),
                                                  ]
                                                )
                                              : _vm._e(),
                                          ]
                                        },
                                      },
                                    ],
                                    null,
                                    true
                                  ),
                                },
                                [
                                  _vm._v(" "),
                                  _c(
                                    "small",
                                    _vm._l(
                                      item.description,
                                      function (description, key) {
                                        return _c("div", { key: key }, [
                                          _vm._v(_vm._s(description)),
                                        ])
                                      }
                                    ),
                                    0
                                  ),
                                ]
                              ),
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c("div", { staticClass: "col-lg-4 mb-2" }, [
                            _c(
                              "span",
                              { staticStyle: { "font-size": ".75rem" } },
                              [
                                _c("b", [_vm._v("AWB:")]),
                                _vm._v(
                                  " " + _vm._s(item.awb ? item.awb.awb : "")
                                ),
                              ]
                            ),
                          ]),
                          _vm._v(" "),
                          _c("div", { staticClass: "col-lg-4 mb-2" }, [
                            _c(
                              "span",
                              { staticStyle: { "font-size": ".75rem" } },
                              [
                                _c("b", [_vm._v("Ruta:")]),
                                _vm._v(
                                  " " +
                                    _vm._s(
                                      item.deliver_route
                                        ? item.deliver_route.route
                                          ? item.deliver_route.route.full_name
                                          : ""
                                        : ""
                                    )
                                ),
                              ]
                            ),
                          ]),
                          _vm._v(" "),
                          _c("div", { staticClass: "col-lg-4 mb-2" }, [
                            _c(
                              "span",
                              { staticStyle: { "font-size": ".75rem" } },
                              [
                                _c("b", [_vm._v("Valor Declarado:")]),
                                _vm._v(
                                  " $ " +
                                    _vm._s(Number(item.value || 0).toFixed(2))
                                ),
                              ]
                            ),
                          ]),
                          _vm._v(" "),
                          _c("div", { staticClass: "col-lg-4 mb-2" }, [
                            _c(
                              "span",
                              { staticStyle: { "font-size": ".75rem" } },
                              [
                                _c("b", [_vm._v("Creado:")]),
                                _vm._v(
                                  " " + _vm._s(_vm._f("DATE")(item.created_at))
                                ),
                              ]
                            ),
                          ]),
                          _vm._v(" "),
                          _c("div", { staticClass: "col-lg-4 mb-2" }, [
                            _c(
                              "span",
                              { staticStyle: { "font-size": ".75rem" } },
                              [
                                _c("b", [_vm._v("Sucursal:")]),
                                _vm._v(
                                  " " +
                                    _vm._s(
                                      item.branch_office
                                        ? item.branch_office.name
                                        : ""
                                    )
                                ),
                              ]
                            ),
                          ]),
                          _vm._v(" "),
                          _c("div", { staticClass: "col-lg-4 mb-2" }, [
                            _c(
                              "span",
                              { staticStyle: { "font-size": ".75rem" } },
                              [
                                _c("b", [_vm._v("Tracking:")]),
                                _vm._v(" " + _vm._s(item.tracking)),
                              ]
                            ),
                          ]),
                          _vm._v(" "),
                          _c("div", { staticClass: "col-lg-4 mb-2" }, [
                            _c(
                              "span",
                              { staticStyle: { "font-size": ".75rem" } },
                              [
                                _c("b", [_vm._v("Actualizado:")]),
                                _vm._v(
                                  " " + _vm._s(_vm._f("DATE")(item.updated_at))
                                ),
                              ]
                            ),
                          ]),
                          _vm._v(" "),
                          _c("div", { staticClass: "col-lg-4 mb-2" }, [
                            _c(
                              "span",
                              { staticStyle: { "font-size": ".75rem" } },
                              [
                                _c(
                                  "router-link",
                                  {
                                    staticClass:
                                      "text-decoration-none text-center sortable",
                                    staticStyle: { "font-size": ".75rem" },
                                    attrs: {
                                      to: {
                                        name: "PackageDetail",
                                        params: { id: item.id },
                                      },
                                    },
                                  },
                                  [
                                    _vm._v(
                                      "\n                                        Más detalles...\n                                    "
                                    ),
                                  ]
                                ),
                              ],
                              1
                            ),
                          ]),
                        ]),
                      ]),
                    ]
                  },
                },
              ],
              null,
              true
            ),
          }),
        ],
      ],
      2
    ),
  ])
}
var staticRenderFns = [
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "card-header" }, [
      _c("h5", { staticClass: "me-auto" }, [_vm._v("Paquetes")]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }